

























































































































































































import Agency from "@/store/entities/agency";
import { Component, Vue } from "vue-property-decorator";

import util from "../lib/util";
@Component({})
export default class TopBarMenu extends Vue {
  fullName: string = "";
  agencyName: string = "";

  data() {
    return {
      menu: false,
    };
  }

  get isCharterDemo() {
    const user = this.$store.state.session.user;
    if (!user) return false;
    const name = String(user.name || "").toLowerCase();
    const userName = String(user.userName || "").toLowerCase();
    return name === "charterdemo" || userName === "charterdemo";
  }

  async created() {

                   await this.$store.dispatch({
         type:'agency/getAgency',
        
         
     })

     

      if(this.$store.state.session.user!=null)
        this.fullName=this.$store.state.session.user.id;
        
        this.agencyName=this.$store.state.agency.select.name;


  }

  logout() {
    this.$store.commit("app/logout", this);
    util.abp.auth.clearToken();
    location.reload();
  }
}
